export default __webpack_public_path__ + "static/media/SG-Red-0002.206208c0.png";